import React from 'react';
import ReactDOM from 'react-dom/client';
import Navbar from './Navbar';
import Intro from './Intro';
import Education from './Education';
import Projects from './Projects';
import Services from './Services';
import Contact from './Contact';
import Footer from './Footer';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Navbar/>
    <Intro/>
    <Education/>
    <Projects/>
    <Services/>
    <Contact/>
    <Footer/>
  </React.StrictMode>
);